import '.jc{border-bottom:1px solid var(--brand-secondary);}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.jd{padding:1.5rem 0;}.ssr-plugin'
import '.c4{border:none;}.ssr-plugin'
import '.d5{background:transparent;}.ssr-plugin'
import '.a1{cursor:pointer;}.ssr-plugin'
import '.gz{text-align:left;}.ssr-plugin'
import '.ap{flex-shrink:0;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.as{justify-content:center;}.ssr-plugin'
import '.eh{width:1.5rem;}.ssr-plugin'
import '.je{font-size:1.25rem;}.ssr-plugin'
import '.cg{font-weight:700;}.ssr-plugin'
import '.jf{padding-bottom:1.125rem;}.ssr-plugin'
import { useId, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons'
import { Text } from '@app/components/core/typography/Text'
import { type Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'

export type FaqItemProps = {
  question: string
  answer: string
  style?: Style
}

export const FaqItem = ({ question, answer, style }: FaqItemProps) => {
  const baseId = useId()
  const panelId = `${baseId}-panel`
  const triggerId = `${baseId}-trigger`
  const [open, setOpen] = useState(false)

  return (
    <styled.div className="jc"
      style={{
        ...style,
      }}
    >
      <button className="a n jd c4 d5 a1 gz"
        type="button"
        id={triggerId}
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((v) => !v)}
      >
        <Title.H3
          style={{
            flex: 1,
            margin: 0,
          }}
        >
          {question}
        </Title.H3>
        <span className="ap a t as eh je cg"
          aria-hidden
        >
          <FontAwesomeIcon icon={open ? faMinus : faPlus} />
        </span>
      </button>
      {open ? (
        <div className="jf"
          id={panelId}
          role="region"
          aria-labelledby={triggerId}
        >
          <Text.Medium
            style={{
              margin: 0,
              color: 'var(--brand-secondary)',
              opacity: 0.85,
              lineHeight: '1.45',
              fontWeight: 400,
            }}
          >
            {answer}
          </Text.Medium>
        </div>
      ) : null}
    </styled.div>
  )
}
